// ModalsLoader.js
import { connect } from 'react-redux';
import getIsAnyModalOpened from '../selector/getIsAnyModalOpened.js';
import ModalsLoader from '../component/ModalsLoader.jsx';

const mapStateToProps = (state, { ids }) => {
  return {
    isAnyModalOpened: ids && getIsAnyModalOpened(state, ids, ['hidden']),
  };
};

export default connect(mapStateToProps)(ModalsLoader);
